<template>
  <div class="main-container">
    <toast-message
      :message="errmsg"
      :isToastEnable="toast"
      type="error"
      @close="(val) => toast = val"
    />
    <div>
      <tl-select
        class="text-capital"
        label="FBP Components"
        labelText="componentName"
        :options="fbpComponentsList"
        v-model="formData.details.details"
        @change="onSelectFBPComponents($event)"
      ></tl-select>
      <div class="error-box" v-if="fbpComponentsList == 0">
        <div class="error-box-text">Not any FBP components are enabled.</div>
        <btn text="Back" type="secondary" @click="cancel" />
      </div>
      <div>
        <div class="innercontainer">
          <div class="threeColumnGrid margin-top-10">
            <txt
              name="forMonth"
              data-vv-as="For Month"
              label="For the Month"
              labelText="forMonth"
              :disabled="true"
              v-model="formData.for_month"
              @change="(val)=>formData.for_month=val"
              v-validate="{required:true}"
              :classname="errors.has('forMonth')"
              :errormsg="errors.first('forMonth')"
            />
            <txt
              name="year"
              data-vv-as="Year"
              label="Year"
              labelText="year"
              :disabled="true"
              v-model="formData.year"
              @change="(val)=>formData.year=val"
              v-validate="{required:true}"
              :classname="errors.has('year')"
              :errormsg="errors.first('year')"
            />
            <!-- <txt
              label="Year"
              type="text"
              v-model="formData.year"
              name="Year"
            /> -->
          </div>

          <div class="threeColumnGrid margin-top-30">
            <txt
              label="Bill Amount"
              type="text"
              v-model="formData.bill_amount"
              name="BillAmount"
              data-vv-as="Bill Amount"
              v-validate="{required:true}"
              :classname="errors.has('BillAmount')"
              :errormsg="errors.first('BillAmount')"
              @change="checkField($event, 'BillAmount')"
              v-numeric-only
            />
            <div>
              <txt
                label="Claim Amount"
                type="text"
                v-model="formData.amount_claimed"
                name="ClaimAmount"
                data-vv-as="Claim Amount"
                v-validate="{required: true }"
                :classname="errors.has('ClaimAmount')"
                :errormsg="errors.first('ClaimAmount')"
                @change="checkField($event, 'ClaimAmount')"
                v-numeric-only
              />
              <span class="errorMessage" v-show="customErrors.claimAmount">
                <span class="error">Claim amount should be less than or equals to bill amount</span>
              </span>
            </div>
            
            <!-- <label class="eligibility-text margin-top-28">
              Eligibility: 45000
            </label> -->
          </div>

          <div class="threeColumnGrid margin-top-30">
            <div>
              <span class="input-label">Bill Date</span>
              <date-picker
                class="customwidth"
                @datevalue="(val) => (formData.bill_date = val)"
                :dates-disabled="{from: new Date(monthYear)}"
                :value="formData.bill_date"
                name="billDate"
                data-vv-as="Bill date"
                data-vv-name="billDate"
                v-validate="{required:true}"
                :classname="errors.has('billDate')"
                :errormsg="errors.first('billDate')"
              />
            </div>

            <txt
              label="Bill Number"
              type="text"
              v-model="formData.bill_number"
              name="BillNumber"
              data-vv-as="Bill Number"
              v-validate="{required:true}"
              :classname="errors.has('BillNumber')"
              :errormsg="errors.first('BillNumber')"
            />
          </div>

          <div class="margin-top-30">
            <div class="upload-heading">Upload Bill <small>(JPG, JPEG or PNG. Max size 5MB)</small></div>
            <upload :tobucket="false" @change="onUploadTemplate($event)" @deleteFile="handleDelete"></upload>
            <!-- <upload></upload> -->
            <span class="errorMessage" v-show="customErrors.uploadFile">
              <span class="error">Please upload bill</span>
            </span>
          </div>

          <div class="threeColumnGrid margin-top-30">
            <div>
              <txt
                label="Approved Amount"
                type="text"
                v-model="formData.amount_approved"
                name="ApprovedAmount"
                data-vv-as="Approved Amount"
                v-validate="{required:true}"
                :classname="errors.has('ApprovedAmount')"
                :errormsg="errors.first('ApprovedAmount')"
                @change="checkField($event, 'ApprovedAmount')"
                v-numeric-only
              />
              <span class="errorMessage" v-show="customErrors.approvedAmount">
                <span class="error">Approved amount should be less than or equals to claim amount</span>
              </span>
            </div>
            <tl-select
              label="Status"
              labelText="status"
              :options="statusData"
              v-model="formData.status"
              @change="(val) => (formData.status = val)"
              name="status"
              data-vv-as="Status"
              v-validate="{required:true}"
              :classname="errors.has('status')"
              :errormsg="errors.first('status')"
            ></tl-select>
          </div>
          <div class="singleColumnGrid margin-top-20">
            <txt
              class="remarks"
              label="Remarks"
              name="remarks"
              type="textarea"
              v-model="formData.remark"
              data-vv-as="Remarks"
              v-validate="{required:true}"
              :classname="errors.has('remarks')"
              :errormsg="errors.first('remarks')"
            />
          </div>
        </div>
        <bottom-action-container >
            <template slot="end">
                <btn-grp>
                    <btn text="Cancel" type="secondary" @click="cancel" />
                    <btn text="Save" type="primary" @click="submit" />
                </btn-grp>
            </template>
        </bottom-action-container>
      </div>
      <div v-if="fbpComponent=='Leave Travel Allowance'">
          <div class="innercontainer">
            <div class="threeColumnGrid margin-top-10">
              <txt 
                label="From"
                type="text" 
                name="from" 
                v-model="journy.from" 
              />
              <txt 
                label="To" 
                name="to" 
                type="text"  
                v-model="journy.to"
              />
            </div>
            <div class="threeColumnGrid margin-top-10">
              <tl-select
                label="Mode of Travel"
                :options="['Flight', 'Train']"
                v-model="journy.mode_of_travel"
                @change="(val) => journy.mode_of_travel=val"
              ></tl-select>
              <txt
                type="number"
                label="Total Distance ( in km)"
                name="distance"
                v-model="journy.distance"
              />
            </div>
            <div class="threeColumnGrid margin-top-30">
              <txt
              class="text-capital"
              name="forMonth"
              data-vv-as="For Month"
              label="For Month"
              labelText="forMonth"
              v-model="formData.for_month"
              @change="(val)=>formData.for_month=val"
              v-validate="{required:true}"
              :classname="errors.has('forMonth')"
              :errormsg="errors.first('forMonth')"
            ></txt>
            <txt
              name="year"
              data-vv-as="Year"
              label="Year"
              labelText="year"
              v-model="formData.year"
              @change="(val)=>formData.year=val"
              v-validate="{required:true}"
              :classname="errors.has('year')"
              :errormsg="errors.first('year')"
            ></txt>
            </div>

            <div class="threeColumnGrid margin-top-30">
              <txt
                label="Bill Amount"
                type="text"
                v-model="formData.bill_amount"
                name="BillAmount"
                data-vv-as="Bill Amount"
                v-validate="{required:true}"
                :classname="errors.has('BillAmount')"
                :errormsg="errors.first('BillAmount')"
                @change="checkField($event, 'BillAmount')"
                v-numeric-only
              />
              <div>
                <txt
                  label="Claim Amount"
                  type="text"
                  v-model="formData.amount_claimed"
                  name="ClaimAmount"
                  data-vv-as="Claim Amount"
                  v-validate="{required: true }"
                  :classname="errors.has('ClaimAmount')"
                  :errormsg="errors.first('ClaimAmount')"
                  @change="checkField($event, 'ClaimAmount')"
                  v-numeric-only
                />
                <span class="errorMessage" v-show="customErrors.claimAmount">
                  <span class="error">Claim amount should be less than or equals to bill amount</span>
                </span>
              </div>
            </div>

            <div class="threeColumnGrid margin-top-30">
              <div>
                <span class="input-label">Bill Date</span>
                <date-picker
                  class="customwidth"
                  @datevalue="(val) => (formData.bill_date = val)"
                  :dates-disabled="{from: new Date(monthYear)}"
                  :value="formData.bill_date"
                  name="billDate"
                  data-vv-as="Bill date"
                  data-vv-name="billDate"
                  v-validate="{required:true}"
                  :classname="errors.has('billDate')"
                  :errormsg="errors.first('billDate')"
                />
              </div>

              <txt
                label="Bill Number"
                type="text"
                v-model="formData.bill_number"
                name="BillNumber"
                data-vv-as="Bill Number"
                v-validate="{required:true}"
                :classname="errors.has('BillNumber')"
                :errormsg="errors.first('BillNumber')"
              />
            </div>

            <div class="margin-top-30">
              <div class="upload-heading">Upload Bill <small>(JPG, JPEG or PNG. Max size 5MB)</small></div>
              <upload :tobucket="false" @change="onUploadTemplate($event)" @deleteFile="handleDelete"></upload>
              <!-- <upload></upload> -->
              <span class="errorMessage" v-show="customErrors.uploadFile">
                <span class="error">Please upload bill</span>
              </span>
            </div>

            <div class="threeColumnGrid margin-top-30">
              <div>
                <txt
                  label="Approved Amount"
                  type="text"
                  v-model="formData.amount_approved"
                  name="ApprovedAmount"
                  data-vv-as="Approved Amount"
                  v-validate="{required:true}"
                  :classname="errors.has('ApprovedAmount')"
                  :errormsg="errors.first('ApprovedAmount')"
                  @change="checkField($event, 'ApprovedAmount')"
                  v-numeric-only
                />
                <span class="errorMessage" v-show="customErrors.approvedAmount">
                  <span class="error">Approved amount should be less than or equals to claim amount</span>
                </span>
              </div>
              <tl-select
                label="Status"
                labelText="status"
                :options="statusData"
                v-model="formData.status"
                @change="(val) => (formData.status = val)"
                name="status"
                data-vv-as="Status"
                v-validate="{required:true}"
                :classname="errors.has('status')"
                :errormsg="errors.first('status')"
              ></tl-select>
            </div>

            <div class="singleColumnGrid margin-top-20">
              <txt
                class="remarks"
                label="Remarks"
                name="remarks"
                type="textarea"
                v-model="formData.remark"
                data-vv-as="Remarks"
                v-validate="{required:true}"
                :classname="errors.has('remarks')"
                :errormsg="errors.first('remarks')"
              />
            </div>
          </div>
          <bottom-action-container>
            <template slot="end">
              <btn-grp>
                <btn text="Cancel" type="secondary" @click="cancel" />
                <btn text="Save" type="primary" @click="submit" />
              </btn-grp>
            </template>
          </bottom-action-container>
      </div>
      <div v-if="fbpComponent=='Telephone Reimbursement' || fbpComponent=='Internet Expense'">
        <div class="innercontainer">
          <div class="threeColumnGrid margin-top-10">
            <txt
              class="text-capital"
              name="forMonth"
              data-vv-as="For Month"
              label="For Month"
              labelText="forMonth"
              v-model="formData.for_month"
              @change="(val)=>formData.for_month=val"
              v-validate="{required:true}"
              :classname="errors.has('forMonth')"
              :errormsg="errors.first('forMonth')"
            ></txt>
            <txt
              name="year"
              data-vv-as="Year"
              label="Year"
              labelText="year"
              v-model="formData.year"
              @change="(val)=>formData.year=val"
              v-validate="{required:true}"
              :classname="errors.has('year')"
              :errormsg="errors.first('year')"
            ></txt>
          </div>

          <div class="threeColumnGrid margin-top-30">
            <txt
              label="Bill Amount"
              type="text"
              v-model="formData.bill_amount"
              name="BillAmount"
              data-vv-as="Bill Amount"
              v-validate="{required:true}"
              :classname="errors.has('BillAmount')"
              :errormsg="errors.first('BillAmount')"
              @change="checkField($event, 'BillAmount')"
              v-numeric-only
            />
            <div>
              <txt
                label="Claim Amount"
                type="text"
                v-model="formData.amount_claimed"
                name="ClaimAmount"
                data-vv-as="Claim Amount"
                v-validate="{required: true }"
                :classname="errors.has('ClaimAmount')"
                :errormsg="errors.first('ClaimAmount')"
                @change="checkField($event, 'ClaimAmount')"
                v-numeric-only
              />
              <span class="errorMessage" v-show="customErrors.claimAmount">
                <span class="error">Claim amount should be less than or equals to bill amount</span>
              </span>
            </div>
          </div>

          <div class="threeColumnGrid margin-top-30">
            <div>
              <span class="input-label">Bill Date</span>
              <date-picker
                class="customwidth"
                @datevalue="(val) => (formData.bill_date = val)"
                :dates-disabled="{from: new Date(monthYear)}"
                :value="formData.bill_date"
                name="billDate"
                data-vv-as="Bill date"
                data-vv-name="billDate"
                v-validate="{required:true}"
                :classname="errors.has('billDate')"
                :errormsg="errors.first('billDate')"
              />
            </div>

            <txt
              label="Bill Number"
              type="text"
              v-model="formData.bill_number"
              name="BillNumber"
              data-vv-as="Bill Number"
              v-validate="{required:true}"
              :classname="errors.has('BillNumber')"
              :errormsg="errors.first('BillNumber')"
            />
          </div>

          <div class="threeColumnGrid margin-top-30">
            <txt
              label="Service Provider" 
              type="text"
              name="service_provider" 
              v-model="model.service_provider" />
            <txt
              label="Mobile Number"
              type="text"
              v-if="fbpComponent=='Telephone Reimbursement'"
              name="mobile_number"
              v-model="model.mobile_number"
            />
            <txt
              label="Account Number"
              v-if="fbpComponent!='Telephone Reimbursement'"
              name="account_number"
              v-model="model.account_number"
            />
          </div>

          <div class="margin-top-30">
            <div class="upload-heading">Upload Phone Bill <small>(JPG, JPEG or PNG. Max size 5MB)</small></div>
            <upload :tobucket="false" @change="onUploadTemplate($event)" @deleteFile="handleDelete"></upload>
            <!-- <upload></upload> -->
            <span class="errorMessage" v-show="customErrors.uploadFile">
              <span class="error">Please upload bill</span>
            </span>
          </div>

          <div class="threeColumnGrid margin-top-30">
            <div>
              <txt
                label="Approved Amount"
                type="text"
                v-model="formData.amount_approved"
                name="ApprovedAmount"
                data-vv-as="Approved Amount"
                v-validate="{required:true}"
                :classname="errors.has('ApprovedAmount')"
                :errormsg="errors.first('ApprovedAmount')"
                @change="checkField($event, 'ApprovedAmount')"
                v-numeric-only
              />
              <span class="errorMessage" v-show="customErrors.approvedAmount">
                <span class="error">Approved amount should be less than or equals to claim amount</span>
              </span>
            </div>
            <tl-select
              label="Status"
              labelText="status"
              :options="statusData"
              v-model="formData.status"
              @change="(val) => (formData.status = val)"
              name="status"
              data-vv-as="Status"
              v-validate="{required:true}"
              :classname="errors.has('status')"
              :errormsg="errors.first('status')"
            ></tl-select>
          </div>

          <div class="singleColumnGrid margin-top-20">
            <txt
              class="remarks"
              label="Remarks"
              name="remarks"
              type="textarea"
              v-model="formData.remark"
              data-vv-as="Remarks"
              v-validate="{required:true}"
              :classname="errors.has('remarks')"
              :errormsg="errors.first('remarks')"
            />
          </div>
        </div>
        <bottom-action-container>
          <template slot="end">
            <btn-grp>
              <btn text="Cancel" type="secondary" @click="cancel" />
              <btn text="Save" type="primary" @click="submit" />
            </btn-grp>
          </template>
        </bottom-action-container>
      </div>
      <div v-if="fbpComponent=='Children Education Allowance' || fbpComponent=='Hostel Allowance'">
        <div class="innercontainer">
          <div class="threeColumnGrid margin-top-10">
            <txt
              class="text-capital"
              name="forMonth"
              data-vv-as="For Month"
              label="For Month"
              labelText="forMonth"
              v-model="formData.for_month"
              @change="(val)=>formData.for_month=val"
              v-validate="{required:true}"
              :classname="errors.has('forMonth')"
              :errormsg="errors.first('forMonth')"
            ></txt>
            <txt
              name="year"
              data-vv-as="Year"
              label="Year"
              labelText="year"
              v-model="formData.year"
              @change="(val)=>formData.year=val"
              v-validate="{required:true}"
              :classname="errors.has('year')"
              :errormsg="errors.first('year')"
            ></txt>
          </div>

          <div class="threeColumnGrid margin-top-30">
            <txt
              label="Bill Amount"
              type="text"
              v-model="formData.bill_amount"
              name="BillAmount"
              data-vv-as="Bill Amount"
              v-validate="{required:true}"
              :classname="errors.has('BillAmount')"
              :errormsg="errors.first('BillAmount')"
              @change="checkField($event, 'BillAmount')"
              v-numeric-only
            />
            <div>
              <txt
                label="Claim Amount"
                type="text"
                v-model="formData.amount_claimed"
                name="ClaimAmount"
                data-vv-as="Claim Amount"
                v-validate="{required: true }"
                :classname="errors.has('ClaimAmount')"
                :errormsg="errors.first('ClaimAmount')"
                @change="checkField($event, 'ClaimAmount')"
                v-numeric-only
              />
              <span class="errorMessage" v-show="customErrors.claimAmount">
                <span class="error">Claim amount should be less than or equals to bill amount</span>
              </span>
            </div>
          </div>

          <div class="threeColumnGrid margin-top-30">
            <div>
              <span class="input-label">Bill Date</span>
              <date-picker
                class="customwidth"
                @datevalue="(val) => (formData.bill_date = val)"
                :dates-disabled="{from: new Date(monthYear)}"
                :value="formData.bill_date"
                name="billDate"
                data-vv-as="Bill date"
                data-vv-name="billDate"
                v-validate="{required:true}"
                :classname="errors.has('billDate')"
                :errormsg="errors.first('billDate')"
              />
            </div>

            <txt
              label="Bill Number"
              type="text"
              v-model="formData.bill_number"
              name="BillNumber"
              data-vv-as="Bill Number"
              v-validate="{required:true}"
              :classname="errors.has('BillNumber')"
              :errormsg="errors.first('BillNumber')"
            />
          </div>

          <div class="threeColumnGrid margin-top-30">
            <txt 
              label="Name of Child" 
              name="child_name" 
              type="text"
              v-model="modelEduChild.child_name" 
            />
            <txt 
              v-if="fbpComponent == 'Children Education Allowance'"
              label="Name of Institute" 
              name="institute_name" 
              type="text"
              v-model="modelEduChild.institute_name"
            />
            <txt 
              v-if="fbpComponent != 'Children Education Allowance'"
              label="Name of Hostel" 
              name="hostel_name" 
              type="text"
              v-model="modelEduChild.hostel_name" 
            />
          </div>

          <div class="margin-top-30">
            <div class="upload-heading">Upload The Fee Slip <small>(JPG, JPEG or PNG. Max size 5MB)</small></div>
            <upload :tobucket="false" @change="onUploadTemplate($event)" @deleteFile="handleDelete"></upload>
            <!-- <upload></upload> -->
            <span class="errorMessage" v-show="customErrors.uploadFile">
              <span class="error">Please upload bill</span>
            </span>
          </div>

          <div class="threeColumnGrid margin-top-30">
            <div>
              <txt
                label="Approved Amount"
                type="text"
                v-model="formData.amount_approved"
                name="ApprovedAmount"
                data-vv-as="Approved Amount"
                v-validate="{required:true}"
                :classname="errors.has('ApprovedAmount')"
                :errormsg="errors.first('ApprovedAmount')"
                @change="checkField($event, 'ApprovedAmount')"
                v-numeric-only
              />
              <span class="errorMessage" v-show="customErrors.approvedAmount">
                <span class="error">Approved amount should be less than or equals to claim amount</span>
              </span>
            </div>
            <tl-select
              label="Status"
              labelText="status"
              :options="statusData"
              v-model="formData.status"
              @change="(val) => (formData.status = val)"
              name="status"
              data-vv-as="Status"
              v-validate="{required:true}"
              :classname="errors.has('status')"
              :errormsg="errors.first('status')"
            ></tl-select>
          </div>

          <div class="singleColumnGrid margin-top-20">
            <txt
              class="remarks"
              label="Remarks"
              name="remarks"
              type="textarea"
              v-model="formData.remark"
              data-vv-as="Remarks"
              v-validate="{required:true}"
              :classname="errors.has('remarks')"
              :errormsg="errors.first('remarks')"
            />
          </div>
        </div>
        <bottom-action-container>
          <template slot="end">
            <btn-grp>
              <btn text="Cancel" type="secondary" @click="cancel" />
              <btn text="Save" type="primary" @click="submit" />
            </btn-grp>
          </template>
        </bottom-action-container>
      </div>
      <div v-if="fbpComponent=='Periodical'">
        <div class="innercontainer">
          <div class="threeColumnGrid margin-top-10">
            <txt
              class="text-capital"
              name="forMonth"
              data-vv-as="For Month"
              label="For Month"
              labelText="forMonth"
              v-model="formData.for_month"
              @change="(val)=>formData.for_month=val"
              v-validate="{required:true}"
              :classname="errors.has('forMonth')"
              :errormsg="errors.first('forMonth')"
            ></txt>
            <txt
              name="year"
              data-vv-as="Year"
              label="Year"
              labelText="year"
              v-model="formData.year"
              @change="(val)=>formData.year=val"
              v-validate="{required:true}"
              :classname="errors.has('year')"
              :errormsg="errors.first('year')"
            ></txt>
          </div>

          <div class="threeColumnGrid margin-top-30">
            <txt
              label="Bill Amount"
              type="text"
              v-model="formData.bill_amount"
              name="BillAmount"
              data-vv-as="Bill Amount"
              v-validate="{required:true}"
              :classname="errors.has('BillAmount')"
              :errormsg="errors.first('BillAmount')"
              @change="checkField($event, 'BillAmount')"
              v-numeric-only
            />
            <div>
              <txt
                label="Claim Amount"
                type="text"
                v-model="formData.amount_claimed"
                name="ClaimAmount"
                data-vv-as="Claim Amount"
                v-validate="{required: true }"
                :classname="errors.has('ClaimAmount')"
                :errormsg="errors.first('ClaimAmount')"
                @change="checkField($event, 'ClaimAmount')"
                v-numeric-only
              />
              <span class="errorMessage" v-show="customErrors.claimAmount">
                <span class="error">Claim amount should be less than or equals to bill amount</span>
              </span>
            </div>
          </div>

          <div class="threeColumnGrid margin-top-30">
            <div>
              <span class="input-label">Bill Date</span>
              <date-picker
                class="customwidth"
                @datevalue="(val) => (formData.bill_date = val)"
                :dates-disabled="{from: new Date(monthYear)}"
                :value="formData.bill_date"
                name="billDate"
                data-vv-as="Bill date"
                data-vv-name="billDate"
                v-validate="{required:true}"
                :classname="errors.has('billDate')"
                :errormsg="errors.first('billDate')"
              />
            </div>

            <txt
              label="Bill Number"
              type="text"
              v-model="formData.bill_number"
              name="BillNumber"
              data-vv-as="Bill Number"
              v-validate="{required:true}"
              :classname="errors.has('BillNumber')"
              :errormsg="errors.first('BillNumber')"
            />
          </div>

          <div class="threeColumnGrid margin-top-30">
            <txt 
              label="Nature of Book Purchased" 
              name="book_nature" 
              type="text"
              v-model="modelPeriodical.book_nature" 
            />
            <txt 
              label="Name of Publisher" 
              name="publisher_name" 
              type="text"
              v-model="modelPeriodical.publisher_name" 
            />
            <txt 
              label="Name of Book" 
              name="book_name" 
              type="text"
              v-model="modelPeriodical.book_name" 
            />
          </div>

          <div class="margin-top-30">
            <div class="upload-heading">Upload Bill <small>(JPG, JPEG or PNG. Max size 5MB)</small></div>
            <upload :tobucket="false" @change="onUploadTemplate($event)" @deleteFile="handleDelete"></upload>
            <!-- <upload></upload> -->
            <span class="errorMessage" v-show="customErrors.uploadFile">
              <span class="error">Please upload bill</span>
            </span>
          </div>

          <div class="threeColumnGrid margin-top-30">
            <div>
              <txt
                label="Approved Amount"
                type="text"
                v-model="formData.amount_approved"
                name="ApprovedAmount"
                data-vv-as="Approved Amount"
                v-validate="{required:true}"
                :classname="errors.has('ApprovedAmount')"
                :errormsg="errors.first('ApprovedAmount')"
                @change="checkField($event, 'ApprovedAmount')"
                v-numeric-only
              />
              <span class="errorMessage" v-show="customErrors.approvedAmount">
                <span class="error">Approved amount should be less than or equals to claim amount</span>
              </span>
            </div>
            <tl-select
              label="Status"
              labelText="status"
              :options="statusData"
              v-model="formData.status"
              @change="(val) => (formData.status = val)"
              name="status"
              data-vv-as="Status"
              v-validate="{required:true}"
              :classname="errors.has('status')"
              :errormsg="errors.first('status')"
            ></tl-select>
          </div>

          <div class="singleColumnGrid margin-top-20">
            <txt
              class="remarks"
              label="Remarks"
              name="remarks"
              type="textarea"
              v-model="formData.remark"
              data-vv-as="Remarks"
              v-validate="{required:true}"
              :classname="errors.has('remarks')"
              :errormsg="errors.first('remarks')"
            />
          </div>
        </div>
        <bottom-action-container>
          <template slot="end">
            <btn-grp>
              <btn text="Cancel" type="secondary" @click="cancel" />
              <btn text="Save" type="primary" @click="submit" />
            </btn-grp>
          </template>
        </bottom-action-container>
      </div>
      <div v-if="fbpComponent=='Professional Development'">
        <div class="innercontainer">
          <div class="threeColumnGrid margin-top-10">
            <txt
              class="text-capital"
              name="forMonth"
              data-vv-as="For Month"
              label="For Month"
              labelText="forMonth"
              v-model="formData.for_month"
              @change="(val)=>formData.for_month=val"
              v-validate="{required:true}"
              :classname="errors.has('forMonth')"
              :errormsg="errors.first('forMonth')"
            ></txt>
            <txt
              name="year"
              data-vv-as="Year"
              label="Year"
              labelText="year"
              v-model="formData.year"
              @change="(val)=>formData.year=val"
              v-validate="{required:true}"
              :classname="errors.has('year')"
              :errormsg="errors.first('year')"
            ></txt>
          </div>

          <div class="threeColumnGrid margin-top-30">
            <txt
              label="Bill Amount"
              type="text"
              v-model="formData.bill_amount"
              name="BillAmount"
              data-vv-as="Bill Amount"
              v-validate="{required:true}"
              :classname="errors.has('BillAmount')"
              :errormsg="errors.first('BillAmount')"
              @change="checkField($event, 'BillAmount')"
              v-numeric-only
            />
            <div>
              <txt
                label="Claim Amount"
                type="text"
                v-model="formData.amount_claimed"
                name="ClaimAmount"
                data-vv-as="Claim Amount"
                v-validate="{required: true }"
                :classname="errors.has('ClaimAmount')"
                :errormsg="errors.first('ClaimAmount')"
                @change="checkField($event, 'ClaimAmount')"
                v-numeric-only
              />
              <span class="errorMessage" v-show="customErrors.claimAmount">
                <span class="error">Claim amount should be less than or equals to bill amount</span>
              </span>
            </div>
          </div>

          <div class="threeColumnGrid margin-top-30">
            <div>
              <span class="input-label">Bill Date</span>
              <date-picker
                class="customwidth"
                @datevalue="(val) => (formData.bill_date = val)"
                :dates-disabled="{from: new Date(monthYear)}"
                :value="formData.bill_date"
                name="billDate"
                data-vv-as="Bill date"
                data-vv-name="billDate"
                v-validate="{required:true}"
                :classname="errors.has('billDate')"
                :errormsg="errors.first('billDate')"
              />
            </div>

            <txt
              label="Bill Number"
              type="text"
              v-model="formData.bill_number"
              name="BillNumber"
              data-vv-as="Bill Number"
              v-validate="{required:true}"
              :classname="errors.has('BillNumber')"
              :errormsg="errors.first('BillNumber')"
            />
          </div>

          <div class="threeColumnGrid margin-top-30">
            <txt 
              label="Name of Institute" 
              name="institute_name" 
              type="text"
              v-model="modelProfessionalDev.institute_name" />
          </div>

          <div class="margin-top-30">
            <div class="upload-heading">Upload Bill <small>(JPG, JPEG or PNG. Max size 5MB)</small></div>
            <upload :tobucket="false" @change="onUploadTemplate($event)" @deleteFile="handleDelete"></upload>
            <!-- <upload></upload> -->
            <span class="errorMessage" v-show="customErrors.uploadFile">
              <span class="error">Please upload bill</span>
            </span>
          </div>

          <div class="threeColumnGrid margin-top-30">
            <div>
              <txt
                label="Approved Amount"
                type="text"
                v-model="formData.amount_approved"
                name="ApprovedAmount"
                data-vv-as="Approved Amount"
                v-validate="{required:true}"
                :classname="errors.has('ApprovedAmount')"
                :errormsg="errors.first('ApprovedAmount')"
                @change="checkField($event, 'ApprovedAmount')"
                v-numeric-only
              />
              <span class="errorMessage" v-show="customErrors.approvedAmount">
                <span class="error">Approved amount should be less than or equals to claim amount</span>
              </span>
            </div>
            <tl-select
              label="Status"
              labelText="status"
              :options="statusData"
              v-model="formData.status"
              @change="(val) => (formData.status = val)"
              name="status"
              data-vv-as="Status"
              v-validate="{required:true}"
              :classname="errors.has('status')"
              :errormsg="errors.first('status')"
            ></tl-select>
          </div>

          <div class="singleColumnGrid margin-top-20">
            <txt
              class="remarks"
              label="Remarks"
              name="remarks"
              type="textarea"
              v-model="formData.remark"
              data-vv-as="Remarks"
              v-validate="{required:true}"
              :classname="errors.has('remarks')"
              :errormsg="errors.first('remarks')"
            />
          </div>
        </div>
        <bottom-action-container>
          <template slot="end">
            <btn-grp>
              <btn text="Cancel" type="secondary" @click="cancel" />
              <btn text="Save" type="primary" @click="submit" />
            </btn-grp>
          </template>
        </bottom-action-container>
      </div>
      <div v-if="fbpComponent=='Driver Salary'">
        <div class="innercontainer">
          <div class="threeColumnGrid margin-top-10">
            <txt
              class="text-capital"
              name="forMonth"
              data-vv-as="For Month"
              label="For Month"
              labelText="forMonth"
              v-model="formData.for_month"
              @change="(val)=>formData.for_month=val"
              v-validate="{required:true}"
              :classname="errors.has('forMonth')"
              :errormsg="errors.first('forMonth')"
            ></txt>
            <txt
              name="year"
              data-vv-as="Year"
              label="Year"
              labelText="year"
              v-model="formData.year"
              @change="(val)=>formData.year=val"
              v-validate="{required:true}"
              :classname="errors.has('year')"
              :errormsg="errors.first('year')"
            ></txt>
          </div>

          <div class="threeColumnGrid margin-top-30">
            <txt
              label="Bill Amount"
              type="text"
              v-model="formData.bill_amount"
              name="BillAmount"
              data-vv-as="Bill Amount"
              v-validate="{required:true}"
              :classname="errors.has('BillAmount')"
              :errormsg="errors.first('BillAmount')"
              @change="checkField($event, 'BillAmount')"
              v-numeric-only
            />
            <div>
              <txt
                label="Claim Amount"
                type="text"
                v-model="formData.amount_claimed"
                name="ClaimAmount"
                data-vv-as="Claim Amount"
                v-validate="{required: true }"
                :classname="errors.has('ClaimAmount')"
                :errormsg="errors.first('ClaimAmount')"
                @change="checkField($event, 'ClaimAmount')"
                v-numeric-only
              />
              <span class="errorMessage" v-show="customErrors.claimAmount">
                <span class="error">Claim amount should be less than or equals to bill amount</span>
              </span>
            </div>
          </div>

          <div class="threeColumnGrid margin-top-30">
            <div>
              <span class="input-label">Bill Date</span>
              <date-picker
                class="customwidth"
                @datevalue="(val) => (formData.bill_date = val)"
                :dates-disabled="{from: new Date(monthYear)}"
                :value="formData.bill_date"
                name="billDate"
                data-vv-as="Bill date"
                data-vv-name="billDate"
                v-validate="{required:true}"
                :classname="errors.has('billDate')"
                :errormsg="errors.first('billDate')"
              />
            </div>

            <txt
              label="Bill Number"
              type="text"
              v-model="formData.bill_number"
              name="BillNumber"
              data-vv-as="Bill Number"
              v-validate="{required:true}"
              :classname="errors.has('BillNumber')"
              :errormsg="errors.first('BillNumber')"
            />
          </div>

          <div class="threeColumnGrid margin-top-30">
            <txt 
              label="Driver Name" 
              name="Driver Name" 
              type="text"
              v-model="modelDriverSal.driver_name" 
            />
            <txt 
              label="License Number" 
              name="License Number" 
              type="text"
              v-model="modelDriverSal.license_number" />
          </div>

          <div class="margin-top-30">
            <div class="upload-heading">Upload Bill <small>(JPG, JPEG or PNG. Max size 5MB)</small></div>
            <upload :tobucket="false" @change="onUploadTemplate($event)" @deleteFile="handleDelete"></upload>
            <!-- <upload></upload> -->
            <span class="errorMessage" v-show="customErrors.uploadFile">
              <span class="error">Please upload bill</span>
            </span>
          </div>

          <div class="threeColumnGrid margin-top-30">
            <div>
              <txt
                label="Approved Amount"
                type="text"
                v-model="formData.amount_approved"
                name="ApprovedAmount"
                data-vv-as="Approved Amount"
                v-validate="{required:true}"
                :classname="errors.has('ApprovedAmount')"
                :errormsg="errors.first('ApprovedAmount')"
                @change="checkField($event, 'ApprovedAmount')"
                v-numeric-only
              />
              <span class="errorMessage" v-show="customErrors.approvedAmount">
                <span class="error">Approved amount should be less than or equals to claim amount</span>
              </span>
            </div>
            <tl-select
              label="Status"
              labelText="status"
              :options="statusData"
              v-model="formData.status"
              @change="(val) => (formData.status = val)"
              name="status"
              data-vv-as="Status"
              v-validate="{required:true}"
              :classname="errors.has('status')"
              :errormsg="errors.first('status')"
            ></tl-select>
          </div>

          <div class="singleColumnGrid margin-top-20">
            <txt
              class="remarks"
              label="Remarks"
              name="remarks"
              type="textarea"
              v-model="formData.remark"
              data-vv-as="Remarks"
              v-validate="{required:true}"
              :classname="errors.has('remarks')"
              :errormsg="errors.first('remarks')"
            />
          </div>
        </div>
        <bottom-action-container>
          <template slot="end">
            <btn-grp>
              <btn text="Cancel" type="secondary" @click="cancel" />
              <btn text="Save" type="primary" @click="submit" />
            </btn-grp>
          </template>
        </bottom-action-container>
      </div>
      <div v-if="fbpComponent=='Vehicle Maintainance'">
        <div class="innercontainer">
          <div class="threeColumnGrid margin-top-10">
            <txt
              class="text-capital"
              name="forMonth"
              data-vv-as="For Month"
              label="For Month"
              labelText="forMonth"
              v-model="formData.for_month"
              @change="(val)=>formData.for_month=val"
              v-validate="{required:true}"
              :classname="errors.has('forMonth')"
              :errormsg="errors.first('forMonth')"
            ></txt>
            <txt
              name="year"
              data-vv-as="Year"
              label="Year"
              labelText="year"
              v-model="formData.year"
              @change="(val)=>formData.year=val"
              v-validate="{required:true}"
              :classname="errors.has('year')"
              :errormsg="errors.first('year')"
            ></txt>
          </div>

          <div class="threeColumnGrid margin-top-30">
            <txt
              label="Bill Amount"
              type="text"
              v-model="formData.bill_amount"
              name="BillAmount"
              data-vv-as="Bill Amount"
              v-validate="{required:true}"
              :classname="errors.has('BillAmount')"
              :errormsg="errors.first('BillAmount')"
              @change="checkField($event, 'BillAmount')"
              v-numeric-only
            />
            <div>
              <txt
                label="Claim Amount"
                type="text"
                v-model="formData.amount_claimed"
                name="ClaimAmount"
                data-vv-as="Claim Amount"
                v-validate="{required: true }"
                :classname="errors.has('ClaimAmount')"
                :errormsg="errors.first('ClaimAmount')"
                @change="checkField($event, 'ClaimAmount')"
                v-numeric-only
              />
              <span class="errorMessage" v-show="customErrors.claimAmount">
                <span class="error">Claim amount should be less than or equals to bill amount</span>
              </span>
            </div>
          </div>

          <div class="threeColumnGrid margin-top-30">
            <div>
              <span class="input-label">Bill Date</span>
              <date-picker
                class="customwidth"
                @datevalue="(val) => (formData.bill_date = val)"
                :dates-disabled="{from: new Date(monthYear)}"
                :value="formData.bill_date"
                name="billDate"
                data-vv-as="Bill date"
                data-vv-name="billDate"
                v-validate="{required:true}"
                :classname="errors.has('billDate')"
                :errormsg="errors.first('billDate')"
              />
            </div>

            <txt
              label="Bill Number"
              type="text"
              v-model="formData.bill_number"
              name="BillNumber"
              data-vv-as="Bill Number"
              v-validate="{required:true}"
              :classname="errors.has('BillNumber')"
              :errormsg="errors.first('BillNumber')"
            />
          </div>

          <div class="threeColumnGrid margin-top-30">
            <txt 
              label="Owner Name" 
              name="Owner Name" 
              type="text"
              v-model="modelVechMaintaince.owner_name" 
            />
            <txt 
              label="Vechicle Number" 
              name="Vechicle Number" 
              type="text"
              v-model="modelVechMaintaince.vechicle_number" />
          </div>

          <div class="margin-top-30">
            <div class="upload-heading">Upload Bill <small>(JPG, JPEG or PNG. Max size 5MB)</small></div>
            <upload :tobucket="false" @change="onUploadTemplate($event)" @deleteFile="handleDelete"></upload>
            <!-- <upload></upload> -->
            <span class="errorMessage" v-show="customErrors.uploadFile">
              <span class="error">Please upload bill</span>
            </span>
          </div>

          <div class="threeColumnGrid margin-top-30">
            <div>
              <txt
                label="Approved Amount"
                type="text"
                v-model="formData.amount_approved"
                name="ApprovedAmount"
                data-vv-as="Approved Amount"
                v-validate="{required:true}"
                :classname="errors.has('ApprovedAmount')"
                :errormsg="errors.first('ApprovedAmount')"
                @change="checkField($event, 'ApprovedAmount')"
                v-numeric-only
              />
              <span class="errorMessage" v-show="customErrors.approvedAmount">
                <span class="error">Approved amount should be less than or equals to claim amount</span>
              </span>
            </div>
            <tl-select
              label="Status"
              labelText="status"
              :options="statusData"
              v-model="formData.status"
              @change="(val) => (formData.status = val)"
              name="status"
              data-vv-as="Status"
              v-validate="{required:true}"
              :classname="errors.has('status')"
              :errormsg="errors.first('status')"
            ></tl-select>
          </div>

          <div class="singleColumnGrid margin-top-20">
            <txt
              class="remarks"
              label="Remarks"
              name="remarks"
              type="textarea"
              v-model="formData.remark"
              data-vv-as="Remarks"
              v-validate="{required:true}"
              :classname="errors.has('remarks')"
              :errormsg="errors.first('remarks')"
            />
          </div>
        </div>
        <bottom-action-container>
          <template slot="end">
            <btn-grp>
              <btn text="Cancel" type="secondary" @click="cancel" />
              <btn text="Save" type="primary" @click="submit" />
            </btn-grp>
          </template>
        </bottom-action-container>
      </div>
    </div>
    <pop-up-message
        v-if="showSuccessMsg"
        :message="responseMsg"
        btnText="Back"
        @back="backfrompopups"
      ></pop-up-message>
      <pop-up-message
        v-if="uploadSuccessMsg"
        :message="responseMsg"
        btnText="Back"
        @back="backfrompopup"
      ></pop-up-message>
  </div>
</template>
<script>
import { mapGetters, mapActions, mapState } from "vuex";
export default {
  data() {
    return {
      fbpComponentsList: [],
      componentList: [],
      fbpComponent: "",
      formData: {
        year: '',
        id: undefined,
        fbp_component_name: '',
        amount_claimed: '',
        bill_amount: '',
        bill_date: '',
        bill_number: '',
        status: '',
        bill: "",
        amount_approved: '',
        remark: '',
        for_month: '',
        year: '',
        fbp_component_id: '',
        employee_id: '',
        legal_entity_id: '',
        details:{}
      },
      // Removing partially approved
      // statusData: [
      //   'Approved',
      //   'Partially Approved',
      //   'Pending',
      //   'Reject'
      // ],
      statusData: [
        'Approved',
        // 'Partially Approved',
        'Pending',
        'Reject'
      ],
      model: {
        service_provider: "",
        mobile_number: "",
        account_number: "",
      },
      billList: [],
      journy: {
        from: "",
        to: "",
        mode_of_trvel: "",
        distance: ""
      },
      modelEduChild: {
        child_name: "",
        institute_name: "",
        hostel_name: "",
      },
      modelPeriodical: {
        book_nature: "",
        publisher_name: "",
        book_name: "",
      },
      modelProfessionalDev: {
        institute_name: "",
      },
      modelDriverSal: {
        driver_name: "",
        license_number: ""
      },
      modelVechMaintaince: {
        owner_name: "",
        vechicle_number: ""
      },
      errmsg: "",
      showSuccessMsg: false,
      uploadSuccessMsg: false,
      toast: false,
      monthIndex: [
        "jan",
        "feb",
        "mar",
        "apr",
        "may",
        "jun",
        "jul",
        "aug",
        "sep",
        "oct",
        "nov",
        "dec"
      ],
      monthYear: "",
      // monthIndex: [],
      // yearList: [
      //   "2020",
      //   "2021",
      //   "2022",
      //   "2023"
      // ],
      customErrors: {
        claimAmount: false,
        approvedAmount: false,
        uploadFile: false
      }
    };
  },
  activated() {
    let index = this.monthIndex.findIndex(item => item === this.payrollMonth.toLowerCase().slice(0, 3));
      let lastday = new Date(this.payrollYear, index + 1, 0);

      let options = { year: 'numeric', month: '2-digit', day: '2-digit' };
      let formattedDate = new Intl.DateTimeFormat('en-US', options).format(lastday);

      this.monthYear = formattedDate;
      this.formData.for_month = this.payrollMonth;
      this.formData.year = this.payrollYear;
    if (this.$route.query.fbpClaimId) {
      this.fetchfbpById();
    } else if (this.$route.query.employeeId) {
      this.formData.employee_id = this.$route.query.employeeId
      this.formData.id = undefined;
    } else {
      this.formData.id = undefined;
      this.formData.employee_id = undefined;
    }
  },
  mounted() {
      this.fetchfbpcomponents();
      // this.for_month = this.payrollMonth;
      this.year = this.payrollYear;
  },
  computed: {
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID",
    }),

    ...mapState({
      globalEmployeeList: (state) =>
        state.globalapi.globalemployees.entityWiseData,
      payrollMonth: state => state.payroll.runpayroll.payrollMonth,
      payrollYear: state => state.payroll.runpayroll.payrollYear
    }),

    yearList() {

      const currentYear = new Date().getFullYear();
      // return Array.from({ length: 5 }, (_, index) => (currentYear + index - 4).toString());
      const startYear = currentYear-5;
      const yearList=[];
      for(let year=startYear;year<=currentYear;year++){
        yearList.unshift(year)
      }
      return yearList;
    },
    
    le_id() {
      if (this.$route.params.entity_index)
        return this.getleid(this.$route.params.entity_index);
      else {
        return this.getleid(0);
      }
    },
  },
  methods: {
    ...mapActions({
      fetchAllComponentList:"dashboard/payroll/utilities/addnewclaim/fetchAllComponentList",
      fetchAllFbpList: "dashboard/payroll/utilities/addnewclaim/fetchAllFbpList",
      act_create:"dashboard/payroll/utilities/addnewclaim/create",
      act_update:"dashboard/payroll/utilities/addnewclaim/update",
      fetchById: "dashboard/payroll/utilities/addnewclaim/fetchEmployeeByNewClaimID",
      act_get_components_monthly_value:"dashboard/payroll/utilities/addnewclaim/fetchFbpcomponentMonthlyValue",
      act_fbp_bills_upload:"dashboard/payroll/utilities/addnewclaim/fbpBillsUploadMethod",
    }),
    
    //SERVICE_FBP_COMPONENTLIST_CLAIM:"/onboarding_le/getFbpEligibilityAllConfig",
    
    // getMonthIndex(index){
    //   const picker={
    //     0:2,
    //     1:3,
    //     2:4,
    //     3:5,
    //     4:6,
    //     5:7,
    //     6:8,
    //     7:9,
    //     8:10,
    //     9:11,
    //     10:12,
    //     11:1
    //   }
    //   const getIndex = picker[index]
    //   return getIndex;
    // },

    async fetchfbpcomponents() {
      try {
        let res = await this.fetchAllComponentList(this.le_id);
        res.data.payload.data.forEach(element => {
          this.fbpComponentsList.push({
            componentName:element.name,
            id: element.id
          });  
        });
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    onSelectFBPComponents(event) {
      //this.fbpComponent = event.componentName;
      this.formData.fbp_component_id = event.id;
      this.formData.fbp_component_name = event.componentName;
      Object.assign(this.formData.details, { details: event.componentName })
      switch(event.componentName) {
          case 'Medical Allowance':
          case 'Leave Travel Allowance':
          case 'Telephone Reimbursement':
          case 'Internet Expense':
          case 'Children Education Allowance':
          case 'Hostel Allowance':
          case 'Periodical':
          case 'Professional Development':  
          case 'Fuel Reimbursement': 
          case 'Business Entertainment':  
          case 'Relocation Allowance':
          case 'Driver Salary':   
          case 'Vehicle Maintainance':
          case 'Food Allowance':
          case 'Gratuity':
          case 'Statutory bonus':    
          default:
            this.fbpComponent = "General";
        }
    },

    handleDelete(val){
      this.formData.docUrl = val
    },

    async fetchfbpById() {
      try {
        let id = this.$route.query.fbpClaimId;
        let res = await this.fetchById(id);
        this.formData.id = res.data.payload.id;
        this.formData.amount_claimed = res.data.payload.amount_claimed;
        this.formData.bill_amount = res.data.payload.bill_amount;
        this.formData.bill_date = res.data.payload.bill_date;
        this.formData.bill_number = res.data.payload.bill_number;
        this.formData.status = res.data.payload.status === 'part_approved' ? 
          'Partially Approved' : res.data.payload.status === 'approved' ? 'Approved' : 'Reject';
        this.formData.docUrl = res.data.payload.bill;
        this.formData.amount_approved = res.data.payload.amount_approved;
        this.formData.remark = res.data.payload.remark;
        this.formData.for_month = res.data.payload.for_month;
        this.formData.year = res.data.payload.year;
        if (typeof res.data.payload.details === "string") {
          Object.assign(this.formData.details, { details: res.data.payload.details });        
        } else {
          this.formData.details = res.data.payload.details;
        }
        this.fbpComponent = this.formData.details.details;
        this.formData.fbp_component_id = res.data.payload.fbp_component_id;
        this.formData.employee_id = res.data.payload.employee_id;
        switch(this.fbpComponent) {
            case 'Leave Travel Allowance':
              if (res.data.payload.details && res.data.payload.details.leaveAllowance) {
                this.journy = res.data.payload.details.leaveAllowance;
              }
            break;
            case 'Telephone Reimbursement':
              if (res.data.payload.details && res.data.payload.details.telephoneReimbusement) {
                this.model = res.data.payload.details.telephoneReimbusement;
              }
            break;
            case 'Internet Expense':
              if (res.data.payload.details && res.data.payload.details.internetExpense) {
                this.model = res.data.payload.details.internetExpense;
              }
            break;
            case 'Children Education Allowance':
              if (res.data.payload.details && res.data.payload.details.educationAllownace) {
                this.modelEduChild = res.data.payload.details.educationAllownace;
              }
            break;
            case 'Hostel Allowance':
              if (res.data.payload.details && res.data.payload.details.hostelAllowance) {
                this.modelEduChild = res.data.payload.details.hostelAllowance;
              }
            break;
            case 'Periodical':
              if (res.data.payload.details && res.data.payload.details.periodical) {
                this.modelPeriodical = res.data.payload.details.periodical;
              }
            break;
            case 'Professional Development':
              if (res.data.payload.details && res.data.payload.details.professionalDev) {
                this.modelProfessionalDev = res.data.payload.details.professionalDev;
              }
            break;  
            case 'Driver Salary':
              if (res.data.payload.details && res.data.payload.details.driverSalary) {
                this.modelDriverSal = res.data.payload.details.driverSalary;
              }
            break; 
            case 'Vehicle Maintainance':
              if (res.data.payload.details && res.data.payload.details.vehicleMaintaince) {
                this.modelVechMaintaince = res.data.payload.details.vehicleMaintaince;
              }
            break;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    submit() {
      try { 
        this.$validator.validateAll().then(result => { 
          if (result && !this.customErrors.claimAmount && !this.customErrors.approvedAmount) { 
            if(!this.formData.docUrl) {
              this.customErrors.uploadFile = true;
            } else {
              this.save();
            }
          } else {
                // to navigate to error fields
            this.$el
              .querySelector(
                '[data-vv-name="' + this.$validator.errors.items[0].field + '"]'
              )
              .focus();
            this.$el
              .querySelector(
                '[data-vv-name="' + this.$validator.errors.items[0].field + '"]'
              )
              .scrollIntoView({
                behavior: "smooth",
                block: "center",
                inline: "center"
              });
            this.toast = true;
            this.errmsg = "Please fill mandatory fields!";
            this.customErrors.uploadFile = false;
          }
        });
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    async onUploadTemplate(event) {
      //   let currentMonthEnum = this.financialMonthOptions.find(
      //   item => item.name == this.monthOptions[new Date().getMonth()]
      // ).value;
      let formData = new FormData();
      formData.append("file", event);
      formData.append("le_id", this.le_id);
      formData.append(
        "financial_year",
        this.payrollYear
      );
      formData.append("emp_id", this.formData.employee_id)
      // formData.append("emp_id", this.employeeId);
      formData.append("month", this.payrollMonth.toLowerCase().slice(0,3));
      this.$root._data.isSaving = true;
      try {
        let res = await this.act_fbp_bills_upload(formData);
        if (res.data && res.data.status) {
          this.responseMsg = res.data.message ? res.data.message : "";
          this.formData.docUrl = res.data.payload.fileUrl;    
          // this.$refs.bulkFile.uploaded = true;
          // this.$refs.bulkFile.uploading = false;
          // this.showSuccessBulkUploadMsg = true;
          this.uploadSuccessMsg = true;
        }
        else {
          this.toast = true;
          this.responseMsg = res.data.message ? res.data.message : "";
          this.errmsg = this.responseMsg;
        }
        setTimeout(() => {
          this.$root._data.isSaving = false;
        }, 500);
      } catch (err) {
        this.$root._data.isSaving = false;
        // this.showSuccessBulkUploadMsg = true;
        this.uploadSuccessMsg = false;
        this.toast = true;
        this.errmsg = err;
      }
    },


    async save() {
      try { 
        this.formData.status = this.formData.status === 'Partially Approved' ? 
        'part_approved' : this.formData.status === 'Approved' ? 'approved' : this.formData.status === 'Pending' ? 'pending' : 'reject';
        this.formData.bill = this.formData.docUrl;
        this.formData.legal_entity_id = this.le_id;
        this.formData.for_month = this.payrollMonth.toLowerCase().slice(0,3);
        switch(this.fbpComponent) {
            case 'Leave Travel Allowance':
              Object.assign(this.formData.details, { leaveAllowance: this.journy });
            break;
            case 'Telephone Reimbursement':
              Object.assign(this.formData.details, { telephoneReimbusement: this.model });
            break;
            case 'Internet Expense':
              Object.assign(this.formData.details, { internetExpense: this.model });
            break;
            case 'Children Education Allowance':
              Object.assign(this.formData.details, { educationAllownace: this.modelEduChild });
            break;
            case 'Hostel Allowance':
              Object.assign(this.formData.details, { hostelAllowance: this.modelEduChild });
            break;
            case 'Periodical':
              Object.assign(this.formData.details, { periodical: this.modelPeriodical });
            break;
            case 'Professional Development':
              Object.assign(this.formData.details, { professionalDev: this.modelProfessionalDev });
            break;  
            case 'Driver Salary':
              Object.assign(this.formData.details, { driverSalary: this.modelDriverSal });
            break; 
            case 'Vehicle Maintainance':
              Object.assign(this.formData.details, { vehicleMaintaince: this.modelVechMaintaince });
            break;
            default:
            break;
        }
        let res;
        if (this.formData.id) {
          res = await this.act_update(this.formData);
        } else {
          res = await this.act_create(this.formData);
        }
        if (res.data && res.data.status) {
          this.responseMsg = res.data.message ? res.data.message : "";
          this.showSuccessMsg = true;
        } else {
          this.toast = true;
          this.errmsg = res.message;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

   /* function to hide successpop-up and go back to main cost centre page */
    backfrompopup() {
      this.uploadSuccessMsg = false;
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/payroll/utilities/addNewClaimFbpComponent`,
      });
    }, 

    backfrompopups() {
      this.showSuccessMsg = false;
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/payroll/utilities/addNewClaimFbpComponent`,
      });
      this.resetForm();
    }, 

    cancel() {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/payroll/fbpPayroll/addNewClaim`,
      });
      this.resetForm();
    },

    resetForm() {
      try {
        this.formData = {
          id: undefined,
          fbp_component_name: '',
          amount_claimed: '',
          bill_amount: '',
          bill_date: '',
          bill_number: '',
          status: '',
          bill: "",
          amount_approved: '',
          remark: '',
          for_month: this.formData.for_month,
          year: this.formData.year,
          fbp_component_id: '',
          employee_id: '',
          legal_entity_id: '',
          details:{}
        };
        this.journy = {
          from: "",
          to: "",
          mode_of_trvel: "",
          distance: ""
        };
        this.model = {
          service_provider: "",
          mobile_number: "",
          account_number: "",
        };
        this.modelEduChild = {
          child_name: "",
          institute_name: "",
          hostel_name: "",
        };
        this.modelPeriodical = {
          book_nature: "",
          publisher_name: "",
          book_name: "",
        };
        this.modelProfessionalDev = {
          institute_name: "",
        };
        this.modelDriverSal = {
          driver_name: "",
          license_number: ""
        };
        this.modelVechMaintaince = {
          owner_name: "",
          vechicle_number: ""
        };
        this.docUrl = "";
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    checkField(value, field) {
      if (field === "BillAmount") {
        if (this.formData.amount_claimed && value) {
          if (Number(value) < Number(this.formData.amount_claimed)) {
            this.customErrors.claimAmount = true;
          } else {
            this.customErrors.claimAmount = false;
          }
        } else {
          this.customErrors.claimAmount = false;
        }
      } else if (field === "ClaimAmount") {
        if (this.formData.bill_amount && value) {
          if (Number(value) > Number(this.formData.bill_amount)) {
            this.customErrors.claimAmount = true;
          } else {
            this.customErrors.claimAmount = false;
          }
        } else {
          this.customErrors.claimAmount = false;
        }
        if (this.formData.amount_approved && value) {
          if (Number(value) < Number(this.formData.amount_approved)) {
            this.customErrors.approvedAmount = true;
          } else {
            this.customErrors.approvedAmount = false;
          }
        }
      } else if (field === "ApprovedAmount")  {
        if (this.formData.amount_claimed && value) {
          if (Number(value) > Number(this.formData.amount_claimed)) {
            this.customErrors.approvedAmount = true;
          } else {
            this.customErrors.approvedAmount = false;
          }
        } else {
          this.customErrors.approvedAmount = false;
        }
      }
    }
  },
};
</script>
<style lang="scss" scoped>
.noData {
  text-align: center;
  padding: 10% 0 10% 0;
  span {
    color: #858585;
    font-size: 18px;
  }
}
.innercontainer {
  padding: 30px 13px;
  margin-bottom: 110px;
}

.threeColumnGrid {
  grid-template-columns: 24% 24% auto;
}

.margin-top-28 {
  margin-top: 28px;
}

.margin-top-30 {
  margin-top: 30px;
}

.margin-top-20 {
  margin-top: 20px;
}

.margin-top-10 {
  margin-top: 10px;
}

.error-box {
  // border: 2px solid red;
  padding: 15px;
  margin-top: 15px;
  border-radius: 5px;
  font-weight: 500;
  font-size: 1.0rem;
  background: #f9f9f9;
}

.error-box-text {
  margin: 15px 0px;
}

.text-capital {
  text-transform: capitalize;
}
</style>
